import { toast } from 'sonner';

import {
    useGetNotificationsQuery,
    useUpdateAllNotificationsAsReadMutation,
} from '@/features/slice/notification';
import { toastError } from '@/utils';

export const useRecentNotifications = () => {
    const { data, isLoading, isError, isFetching, error, refetch } =
        useGetNotificationsQuery(
            {
                status: 'unread',
                limit: 100,
                page: 1,
                sort_by: 'created_at',
                sort_order: 'desc',
            },
            {
                pollingInterval: 200 * 1000,
            },
        );

    const [updateAllNotificationsAsRead, { isLoading: isUpdateAllLoading }] =
        useUpdateAllNotificationsAsReadMutation();

    const handleUpdateAllAsRead = async () => {
        try {
            await updateAllNotificationsAsRead({}).unwrap();
            toast.success('Successfully updated');
        } catch (err) {
            toastError(err, 'Failed to update all notifications as read');
        }
    };

    const handleRefresh = async () => {
        refetch();
    };

    return {
        data,
        isLoading,
        isError,
        isFetching,
        error,
        isUpdateAllLoading,
        handleUpdateAllAsRead,
        handleRefresh,
    };
};
